import WarningIcon from "@mui/icons-material/Warning"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import { axiosClient } from "../../../common/axios"
import TextLink from "../../../common/components/TextLink"
import LoadingPaper from "../components/LoadingPaper"
import PageTitle from "../components/PageTitle"

export default function EmailConfirmationInvalid() {
  const [isLoading, setIsLoading] = useState(false)
  const [email, setEmail] = useState("")
  const [emailError, setEmailError] = useState("")

  function handleEmailChanged(e) {
    setEmail(e.target.value)
    setEmailError("")
  }

  function handleResendLinkButtonClicked() {
    setIsLoading(true)
    axiosClient
      .post("/users/api/resend-confirmation/", { email })
      .then(() => navigate("/user/signup-success"))
      .catch(({ response: { data } }) => {
        setEmailError(data.email)
      })
      .then(() => setIsLoading(false))
  }

  const navigate = useNavigate()

  return (
    <>
      <PageTitle text="Email confirmation link invalid" />
      <LoadingPaper isLoading={isLoading}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <WarningIcon color="warning" fontSize="large" />
        </Box>
        <Typography variant="body1" sx={{ mt: (theme) => theme.spacing(2) }}>
          It looks like the confirmation link you used may have expired. You can
          request a new one for your email below.
        </Typography>
        <TextField
          size="small"
          label="Email Address"
          value={email}
          onChange={handleEmailChanged}
          required
          error={!!emailError}
          helperText={emailError}
          sx={{ mt: (theme) => theme.spacing(2) }}
          fullWidth
        />
        <Button
          variant="contained"
          sx={{ mt: (theme) => theme.spacing(4) }}
          disabled={!email}
          onClick={handleResendLinkButtonClicked}
        >
          Resend Link
        </Button>
        <Typography variant="body1" sx={{ mt: (theme) => theme.spacing(2) }}>
          Or try to <TextLink to="/user/log-in" text="log in" /> again.
        </Typography>
      </LoadingPaper>
    </>
  )
}
